import React, { useState, useEffect } from "react";
import { Drawer, Timeline } from "antd";
import { DataProvider } from "../../DataProvider";
import { useLocation } from "react-router-dom";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import FormLoader from "swfrontend/MDM/MDMScreens/FormView/FormLoader";
import Modal from "react-bootstrap/Modal";
import dayjs from "dayjs";
import { DownloadOutlined } from "@ant-design/icons";
import { BASE_URL } from "../../../App/Configs/AppConfigs";

import NewClaim from "../NewClaim/NewClaim";


const ViewClaim = () => {
  const location = useLocation();
  const { contractData } = location.state || {};
  const dataProvider = new DataProvider();

  const [projectData, setProjectData] = useState(null);
  const [updateData, setUpdateData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [open, setOpen] = useState(false);

  const sortDataByCreatedDate = (data) => {
    return data
      .sort((a, b) => b.id - a.id)
      .map((item) => ({
        ...item,

        created: dayjs(item.created),
      }));
  };

  const showDrawer = () => {
    if (updateData.length > 0) {
      setOpen(true);
    } else {
      openNotification("info", "Not found", "No discussions for this claim!");
      setOpen(false);
    }
  };
  const onClose = () => {
    setOpen(false);
  };

  const getProjectDetails = () => {
    dataProvider
      .getSpecificValue("MstProject", contractData["contract_project"])
      .then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            setLoader(true);
            const value = {
              ...contractData,
              contract_project: data?.project_name,
              contract_project_id: data?.project_id,
              contract_program: data?.program?.program_name,
              contract_location: data?.program?.location?.location_name,
              contract_start_date: dayjs(contractData?.contract_start_date),
              contract_end_date: dayjs(contractData?.contract_end_date),
              upto_date: dayjs(contractData?.upto_date),
              contract_date: dayjs(contractData?.contract_date),
            };
            setProjectData(value);
          });
        } else {
          response.json().then((responseJson) => {
            openNotification("error", "Error", responseJson["message"]);
          });
        }
      })
      .catch((exception) =>
        openNotification("error", "Error", "Error connecting server")
      )
      .finally(() => {
        setLoader(false);
      });
  };

  const getDiscussionData = () => {
    dataProvider
      .getDiscussions(contractData?.id)
      .then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            setLoader(true);
            setUpdateData(sortDataByCreatedDate(data));
          });
        } else {
          response.json().then((responseJson) => {
            openNotification("error", "Error", responseJson["message"]);
          });
        }
      })
      .catch((exception) => {
        openNotification("error", "Error", "Error connecting server");
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const DownloadFile = (e, filename) => {
    e.preventDefault(); // Prevent default anchor behavior
    dataProvider
      .downloadFile("discussion", `${filename}`)
      .then((response) => {
        if (response.status == 200) {
          response.blob().then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const tempLink = document.createElement("a");
            const filenameValue = filename.split('&').find(param => param.startsWith('file=') || param.includes('letter_file')).split('=')[1]
            tempLink.href = url;

            tempLink.download = filenameValue.split("/").pop(); // Use the file name from the API
            document.body.appendChild(tempLink);
            tempLink.click();
            tempLink.remove();
            window.URL.revokeObjectURL(url);
          });
        } else {
          response.json().then((responseJson) => {
            openNotification("error", "Error", responseJson["message"]);
          });
        }
      })
      .catch(() => {
        openNotification("error", "Error", "Error fetching the file");
      });
  };

  useEffect(() => {
    getProjectDetails();
    getDiscussionData();
  }, []);

  return (
    <div>
      <div>
        {projectData ? (
          <NewClaim
            disabled={true}
            contractData={projectData}
            showDrawer={showDrawer}
          />
        ) : (
          <Modal show={loader} centered>
            <Modal.Body>
              <FormLoader loading={loader} />
            </Modal.Body>
          </Modal>
        )}
      </div>

      <Drawer
        title="Claim Updates"
        onClose={onClose}
        open={open}
        getContainer={false}
        width={500}
        placement="right"
        style={{ position: "fixed", marginTop: "2%" }}
      >
        <Timeline>
          {updateData.map((item, index) => (
            <Timeline.Item key={index} color="green">
              <p>
                <strong>Status:</strong> {item?.status.toUpperCase()}
              </p>
              <p>Letter : {item?.letter_number}</p>
              <p>
                {item?.status.toUpperCase() +
                  " by " +
                  item?.created_by_username +
                  " on " +
                  dayjs(item?.created).format("YYYY-MM-DD HH:mm:ss")}
              </p>
              <p>{"Update: " + item?.updates}</p>
              {item?.file !== undefined ? (
                item?.file?.map((file) => (
                  <a
                    href={`${BASE_URL.replace("/api", "")}${file}`}
                    download={file.split("/").pop()} // Triggers a download when clicked
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e, _) =>
                      DownloadFile(e, `file=${file.replace("/", "")}&request_id=${contractData?.id}`)
                    }
                  >
                    <DownloadOutlined />
                    {file.split("/").pop()}
                    <br />
                  </a>
                ))
              ) : (
                <p>No supporting document</p>
              )}
              {item?.letter_file !== undefined ? (
                item?.letter_file?.map((file) => (
                  <a
                    href={`${BASE_URL.replace("/api", "")}${file}`}
                    download={file.split("/").pop()} // Triggers a download when clicked
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e, _) =>
                      DownloadFile(e, `letter_file=${file.replace("/", "")}&request_id=${contractData?.id}`)
                    }
                  >
                    <DownloadOutlined />
                    {file.split("/").pop()}
                    <br />
                  </a>
                ))
              ) : (
                <p>No letter</p>
              )}
            </Timeline.Item>
          ))}
        </Timeline>
      </Drawer>

    </div>
  );
};

export default ViewClaim;
